(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df-sarah-clarity"] && !Shopify.designMode) return;
  try {
    (function () {
  var sent = false;
  var mounted = false;
  var discovery;
  function bindWidget() {
    if (mounted) return true;
    var loader = document.querySelector('script[data-widget-id="668b7ffbdad1ad7c443c3428"]');
    if (!loader) return false;
    var instance = loader.getAttribute('data-loader-instance');
    if (!instance) return false;
    var widgets = document.querySelectorAll('chat-widget');
    var widget;
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].getAttribute('data-loader-instance-id') === instance) widget = widgets[i];
    }
    if (!widget) return false;
    mounted = true;
    widget.setAttribute('data-df-sarah-tracking', 'ready');
    var active = widget.getAttribute('data-active') === 'true';
    var stateObserver = new MutationObserver(function () {
      var nextActive = widget.getAttribute('data-active') === 'true';
      var opened = nextActive && !active;
      active = nextActive;
      if (!opened || sent) return;
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
          !privacy.analyticsProcessingAllowed() || typeof window.clarity !== 'function') return;
      window.clarity('event', 'sarah_chat_opened');
      sent = true;
      widget.setAttribute('data-df-sarah-tracking', 'event-sent');
      stateObserver.disconnect();
    });
    stateObserver.observe(widget, { attributes: true, attributeFilter: ['data-active'] });
    if (discovery) discovery.disconnect();
    return true;
  }
  function start() {
    if (bindWidget()) return;
    discovery = new MutationObserver(bindWidget);
    discovery.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('LC_chatWidgetLoaded', bindWidget);
    window.setTimeout(function () {
      discovery.disconnect();
      window.removeEventListener('LC_chatWidgetLoaded', bindWidget);
    }, 30000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
  } catch(e) { console.error(e); }
})();

})();
